
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddOrderStockPositionDtoFormGroup() {
return new FormGroup({
    lagerProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    itemId: new FormControl<number | undefined>(undefined, [Validators.required]),
    targetAmount: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(0.001)]),
})
;
}
      